import { apiSlice } from "../apiSlice";

export const fileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uplaodFile: builder.mutation({
      query: (data) => ({
        url: "/file",
        method: "POST",
        body: data,
        // headers: {
        //   "Content-Type": "multipart/form-data",
        // },
        credentials: "include",
      }),
    }),
  }),
});

export const { useUplaodFileMutation } = fileApi;
